import type { Booking } from '@coachapp/shared';

/** Most recent non-cancelled booking for a client (by start time). */
export function getLastBookingForClient(
  bookings: Booking[],
  clientId: string,
): Booking | undefined {
  let latest: Booking | undefined;

  for (const booking of bookings) {
    if (booking.clientId !== clientId || booking.status === 'CANCELLED') continue;
    if (!latest || new Date(booking.startsAt).getTime() > new Date(latest.startsAt).getTime()) {
      latest = booking;
    }
  }

  return latest;
}

export function resolveLastSessionDefaults(
  lastBooking: Booking | undefined,
  planIdsForClient: Set<string>,
): { trainingPlanId: string; durationMinutes: number } | null {
  if (!lastBooking) return null;

  const trainingPlanId =
    lastBooking.trainingPlanId && planIdsForClient.has(lastBooking.trainingPlanId)
      ? lastBooking.trainingPlanId
      : '';

  return {
    trainingPlanId,
    durationMinutes: lastBooking.durationMinutes || 60,
  };
}
